module.exports = __webpack_public_path__ + "img/5.9385aed1.png";